<table data-cy="material-list-detail" class="list-table accordion-materials-list">
  <thead>
    <tr class="list-row" data-cy="material-list-detail-header-row">
      <th class="list-header-element material-transport-number-column material-list-detail-column">
        <app-tooltip message="Transport number">
          <span data-cy="material-list-transport-number-header">Transport number</span>
        </app-tooltip>
      </th>
      <th class="list-header-element material-sent-quantity-column material-list-detail-column">
        <app-tooltip message="Sent quantity">
          <span data-cy="material-list-sent-quantity-header">Sent quantity</span>
        </app-tooltip>
      </th>
      @if (transportDocument) {
        <th class="list-header-element material-transport-document-column">
          <app-tooltip message="{{transportDocument | undefinedValue}}">
            <span data-cy="material-list-transport-document-header">{{transportDocument | undefinedValue}}</span>
          </app-tooltip>
        </th>
      }
      <th class="list-header-element material-handling-column-column">
        <app-tooltip message="Handling unit">
          <span data-cy="material-list-handling-column-header">Handling unit</span>
        </app-tooltip>
      </th>
      <th class="list-header-element material-est-arrival-column">
        <app-tooltip message="Est. arrival">
          <span data-cy="material-list-est-arrival-header">Est. arrival</span>
        </app-tooltip>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (delivery of materialDeliveries; track delivery) {
      <tr class="list-row" data-cy="material-list-detail-row">
        <td class="list-element">
          <app-tooltip message="{{delivery.transportNumber | undefinedValue}}">
            <span data-cy=material-list-detail-element-transportNumber>{{delivery.transportNumber | undefinedValue}}</span>
          </app-tooltip>
        </td>
        <td class="list-element">
          <app-tooltip message="{{delivery.sentQuantity | undefinedValue}} {{materialUnits}}">
            <span data-cy=material-list-detail-element-sentQuantity>{{delivery.sentQuantity | undefinedValue}}
              <span>{{materialUnits}}</span></span>
            </app-tooltip>
          </td>
          @if (transportDocument) {
            <td
              class="list-element">
              <app-tooltip message="{{delivery.transportDocumentNumber | undefinedValue}}">
                <span data-cy=material-list-detail-element-transportDocumentNumber>{{delivery.transportDocumentNumber | undefinedValue}}</span>
              </app-tooltip>
            </td>
          }
          <td class="list-element">
            <app-tooltip message="{{delivery.handlingUnit | undefinedValue}}">
              <span data-cy=material-list-detail-element-handlingUnit>{{delivery.handlingUnit | undefinedValue}}</span>
            </app-tooltip>
          </td>
          <td class="list-element">
            <app-tooltip message="{{delivery.estimatedTimeArrival | date:'dd-MM-yyyy'}}">
              <span data-cy=material-list-detail-element-estimatedTimeArrival>{{delivery.estimatedTimeArrival | utcAsLocal | date:'dd-MM-yyyy'}}</span>
            </app-tooltip>
          </tr>
        }
      </tbody>
    </table>
